/**
 * @author Tommy Brière
 * @copyright (c) 2015 Groupe PVP
 * @fileoverview Killable callback group
 **/
(function ($g) {
    "use strict";

    function Killable() {
        var delaySession = 0;

        this.delay = function (f) {
            var session = delaySession;
            function callback() {
                var args = arguments;
                if (delaySession === session) {
                    f.apply(null, args);
                }
            }

            return callback;
        };

        /**
         * Kill all timeout registered with this object
         * Timeout not registered with this object wont be cancelled
         * @return
         */
        this.killDelayed = function () {
            delaySession++;
        };

    }

    $g.Killable = Killable;

})(PVPGEngine);